module.exports = __webpack_public_path__ + "static/media/digital-work7.ef07c04e.jpg";